export const PRIORITIES = Object.freeze({
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
  UNDEFINED: "UNDEFINED",
});

export const STATUSES = Object.freeze({
  REPORTED: "REPORTED",
  CONFIRMED: "CONFIRMED",
  SCHEDULED: "SCHEDULED",
  RESOLVED: "RESOLVED",
  REJECTED: "REJECTED",
});

export const REPORTERS = Object.freeze({
  CITIZEN: "citizen",
  DRONE: "drone",
  SATELLITE: "satellite",
  STREET_CAMERA: "street camera",
  ON_BOARD_UNIT: "on-board unit",
});

export const ACTIVE_STATUSES = Object.freeze([
  STATUSES.REPORTED,
  STATUSES.CONFIRMED,
  STATUSES.SCHEDULED,
]);

export const HISTORIC_STATUSES = Object.freeze([
  STATUSES.RESOLVED,
  STATUSES.REJECTED,
]);

export const STATUS_TRANSITIONS = Object.freeze({
  [STATUSES.REPORTED]: [STATUSES.CONFIRMED],
  [STATUSES.CONFIRMED]: [STATUSES.SCHEDULED],
  [STATUSES.SCHEDULED]: [STATUSES.RESOLVED, STATUSES.REJECTED],
  [STATUSES.RESOLVED]: [],
  [STATUSES.REJECTED]: [],
});

export const PRIORITY_COLORS = Object.freeze({
  [PRIORITIES.HIGH]: "#ef4444",
  [PRIORITIES.MEDIUM]: "#f59e0b",
  [PRIORITIES.LOW]: "#22c55e",
  [PRIORITIES.UNDEFINED]: "#9ca3af",
});

export const DEFAULT_PRIORITY = PRIORITIES.UNDEFINED;

export const DEFAULT_STATUS = STATUSES.REPORTED;

export const Incident = {
  id: "",
  latitude: 0,
  longitude: 0,
  timestamp: "",
  reporter: REPORTERS.CITIZEN,
  priority: PRIORITIES.UNDEFINED,
  status: STATUSES.REPORTED,
  description: "",
  segmentId: null,
  photoUrl: null,
};
